<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <role-header :title="title" :path="path" :text="text" :text1="text1" @addRolesClick="addRolesClick" />
      <!-- /Page Header -->

      <div class="row">
        <div class="col-md-12">

          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="rolesOptions" :pagination="false"
                v-if="rolesOptions">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'name'">
                    {{ record.name }}
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <div>
                      <div class="dropdown dropdown-action">
                        <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">

                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#edit_company_role" @click="editClicked(record)"><i
                              class="fa-solid fa-pencil m-r-5"></i> Edit</a>
                          <!-- <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_company_role" @click="editClicked(record)"><i
                            class="fa-solid fa-trash m-r-5"></i>Delete</a> -->
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No Location have been added.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <add-role-modal ref="addRole" @roleModal="getRoles"></add-role-modal>

  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { getImage } from "@/utils/util-funcitons";
const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id"
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },

  {
    title: "Action",
    // sorter: true,
    key: "action",
  },
];

export default {
  data() {
    return {
      columns,
      title: "Roles",
      path: "Dashboard",
      text: "Roles",
      text1: "Add Role",
      scheduleData: [],
      perPage: 10,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      loader: false,
      rolesOptions: []
    };
  },
  mounted() {
    this.getRoles()
  },

  methods: {
    getImage,

    async getRoles() {
      this.loader = true;
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.rolesOptions = response.data.data
          } else {
            this.errorMessage = response.data.message || response.data.errors;
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    editClicked(record) {
      this.$refs.addRole.editRole(record);
    },

  }
};
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

.table-responsive {
  height: 100vh;
  overflow: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}
</style>
